import { useState } from "react";
import BoxEmail from "./boxEmail"

const BoxEmailList = (props: any) => {
  let emails = props.emails ?? [];

  const deleteEmail = (idEmail: any) => {
    let a = emails.filter((pro: any, index: any) => index != idEmail);
    props.handelUpdate(a)
  }
  return (
    <>
      {emails.map((email: any, index: any) => (
        <BoxEmail deleteEmail1={deleteEmail} email={email} id={index} key={index} />
      ))}
    </>
  )
}

export default BoxEmailList